import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setCurrentUser } from '../actions/user'
import { RegisterForm } from '../components/auth/register_form'
import { axiosPost } from '../util/api'
import { Toasts } from '../components/toaster/Toast'
export const Register = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [coupon, setCoupon] = useState<any | null>(null)

    useEffect(() => {
        // @ts-ignore
        window.rewardful('ready', function () {
            // @ts-ignore
            if (Rewardful.coupon) {
                // @ts-ignore
                setCoupon(Rewardful?.coupon)
            }
        })
    }, [])

    const register = ({ name, email, password, passwordConfirm }: any) => {
        setLoading(true)
        axiosPost(
            'register',
            {
                name,
                email,
                password,
                password_confirmation: passwordConfirm,
                coupon: coupon?.id,
            },
            true,
        )
            .then((res) => {
                setLoading(false)
                dispatch(setCurrentUser(res.data))
                Toasts.success('Registration successful')
                navigate('/onboard')
            })
            .catch(() => {
                setLoading(false)
            })
    }

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <RegisterForm onSubmit={register} loading={loading} coupon={coupon} />
        </div>
    )
}
